import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import logo from "../../assets/images/vozo-logo-1.png";
import renew from "../../assets/images/renew.png";
import dataexport from "../../assets/images/dataexport.png";
import { Decrypt_Value, Encrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import axiosInstance from "../../axios/axios";

const generateRandomPassword = (length = 10) => {
  const charset =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
  return Array.from(
    { length },
    () => charset[Math.floor(Math.random() * charset.length)],
  ).join("");
};

export default function ReNewPage() {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    history.push("/DataExport"); // 👈 redirect
  };
  const handleReactivate = () => {
    setLoading(true);

    const uid =
      localStorage.getItem("user_id") &&
      Decrypt_Value(localStorage.getItem("user_id"), "vozo");

    if (!uid) {
      console.error("Missing uid");
      setLoading(false);
      return;
    }

    axiosInstance
      .get("/vozo/loginemail?uid=" + uid)
      .then((res) => {
        const data = Decrypt_Value(res.data, "vozo");

        const randomPassword = generateRandomPassword();
        const EncryptrandomPassword = Encrypt_Value(randomPassword, "vozo");

        const url = new URL("https://signup.vozohealth.com/plan-purchase.php");
        url.searchParams.append("token", EncryptrandomPassword);
        url.searchParams.append("email", data.email);

        // fire API
        axiosInstance
          .put("/vozo/feedbackloginpass?uid=" + uid, EncryptrandomPassword)
          .catch(() => {});

        // redirect
        // window.open(url.toString(), "_blank");
        localStorage.clear();
        window.location.href = url.toString();
      })
      .catch(() => {
        console.error("Failed to fetch email");
        setLoading(false);
      });
  };

  return (
    <div className="wwtd-page">
      {/* Logo */}
      <div className="wwtd-logo">
        <img src={logo} alt="VOZO" style={{ height: "80px", width: "120px" }} />
      </div>

      {/* Card */}
      <div className="wwtd-card">
        <div className="wwtd-header">
          <div className="wwtd-title">What would you like to do?</div>
          <div className="wwtd-subtitle">
            Choose an option below to manage your account.
          </div>
        </div>

        <div className="wwtd-options">
          {/* Renew */}
          <button className="wwtd-option" onClick={handleReactivate}>
            <div className="option-icon-box">
              <img src={renew} alt="Renew" className="option-icon-img" />
            </div>
            <div className="option-text">
              <span className="option-title">Renew Subscription</span>
              <span className="option-desc">
                Reactivate your plan and continue using all features
              </span>
            </div>
          </button>

          {/* Export */}
          <button className="wwtd-option" onClick={handleExport}>
            <div className="option-icon-box">
              <img src={dataexport} alt="Export" className="option-icon-img" />
            </div>
            <div className="option-text">
              <span className="option-title">Data Export</span>
              <span className="option-desc">
                Download a copy of your account data
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
